import React from 'react';
import { Link } from 'react-router-dom';
import './StatusPage.css';
import { useLiteralDocumentTitle } from '../Hooks/useDocumentTitle';

function StatusAction({ action, variant }) {
  if (!action) {
    return null;
  }

  const className = `status-page__action status-page__action--${variant}`;

  if (action.to) {
    return (
      <Link className={className} to={action.to} onClick={action.onClick}>
        {action.label}
      </Link>
    );
  }

  return (
    <button className={className} type="button" onClick={action.onClick}>
      {action.label}
    </button>
  );
}

export default function StatusPage({
  statusCode = '404',
  eyebrow = 'Page not found',
  title = 'We could not find that page.',
  message = 'The link may be outdated, or the page may have moved.',
  primaryAction,
  secondaryAction,
  details,
  onReset,
}) {
  useLiteralDocumentTitle(eyebrow);
  return (
    <section className="status-page" aria-labelledby="status-page-title">
      <div className="status-page__panel">
        <p className="status-page__code">{statusCode}</p>
        <p className="status-page__eyebrow">{eyebrow}</p>
        <h1 id="status-page-title" className="status-page__title">
          {title}
        </h1>
        <p className="status-page__message">{message}</p>

        <div className="status-page__actions" role="group" aria-label="Page recovery actions">
          <StatusAction action={primaryAction} variant="primary" />
          <StatusAction action={secondaryAction} variant="secondary" />
          {onReset && (
            <button
              className="status-page__action status-page__action--secondary"
              type="button"
              onClick={onReset}
            >
              Try again
            </button>
          )}
        </div>

        {details && <pre className="status-page__details">{details}</pre>}
      </div>
    </section>
  );
}
